import { Club } from './Club'
import { User } from '../User/User'

export enum ClubEntryStatus {
  INVITED = 0,
  ACCEPTED = 1,
  REFUSED = 2,
  REMOVED = 3,
  REQUESTED = 4,
  COMPLETED = 5,
  EXPIRED = 6,
}

export enum ClubEntryType {
  MANUAL = 0,
  SELF_ONBOARDING = 1,
}

export interface ClubEntry {
  id: string
  email: string
  firstname: string
  lastname: string
  amount?: number | null
  status: ClubEntryStatus
  type: ClubEntryType
  userId?: string
  user?: User | null
  clubId: string
  club: Club
  updatedAt: Date
  createdAt: Date
}
